import Cookies from 'js-cookie'

const TokenKey = 'WxPub-Token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  console.log('tk:' + token)
  let expires = new Date(new Date().getTime() + 60 * 60 * 1000);
  return Cookies.set(TokenKey, token, {expires: expires})
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function toLogin(page) {
  removeToken()
  // console.log('tologin:' + page)
  if(!page){
    let search = window.location.search || ''
    if(search.indexOf('apply') > 0){
      page = "apply"
    } else {
      page = "order"
    }
  }
  // location.href = 'http://localhost:8080'+ process.env.VUE_APP_BASE_API +'/wxpubapis/toLogin?page=' + page
  location.href = process.env.VUE_APP_BASE_API +'/wxpubapis/toLogin?page=' + page
}
